import React from "react";
import PropTypes from "prop-types";
import DatabaseLink from "./DatabaseLink";
import AccessionSubmission from "../../../../models/AccessionSubmission";

function SubmissionRow({ submission, tdClass }) {
  return (
    <tr className="tw-shadow-inner tw-bg-blueGray-50 tw-border tw-border-blueGray-500">
      <td className={tdClass}>
        <div className="tw-font-semibold">Submitter:</div>
        {submission.submitterName || "Not found"}
      </td>
      <td className={tdClass}>
        <div>{submission.reviewDate}</div>
        <div>{submission.reviewStatus}</div>
      </td>
      <td className={tdClass}>{submission.significanceArr.join(", ")}</td>
      <td className={tdClass}>{submission.origin || "-"}</td>
      <td className={tdClass}>{submission.method || "-"}</td>
      <td className={tdClass}>
        {submission.diseaseItems.map((x, i) => (
          <span className="" key={`${new Date().getTime()}-${i}`}>
            <DatabaseLink {...x} />
            {i < submission.diseaseItems.length - 1 ? ", " : ""}
          </span>
        ))}

        <div>{submission.findings.join(", ")}</div>
      </td>
    </tr>
  );
}

SubmissionRow.propTypes = {
  tdClass: PropTypes.string.isRequired,
  submission: PropTypes.instanceOf(AccessionSubmission).isRequired,
};

export default React.memo(SubmissionRow);
